import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { breadcrumb, breadcrumbResolve, breadcrumbResolved } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class AnnouncementRoute extends Route {
  @service store;

  @breadcrumb
  crumb = [
    { text: 'Announcements', route: 'announcements' },
    { text: 'Announcement' },
  ];

  model(params) {
    return hash({
      announcement: this.store.findRecord('announcement', params.announcement_id),
    });
  }

  @breadcrumbResolve
  modelCrumbResolve(model) {
    return model.announcement;
  }
  @breadcrumbResolved
  modelCrumb(model) {
    return model.announcement.get('title');
  }
}
